module.exports = {

    methods: {
        openHomeTab: function () {
            this.$router.push('meeting-home');

        }
    }
}

